module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/Responsible.9c7ab9bc.svg";